import { FC } from 'react'
import { useDraggable } from '@dnd-kit/core'
import { FORM_ELEMENT_ICONS, FORM_ELEMENT_TYPES } from '@mobileConstants'
import { DragIndicator } from '@mui/icons-material'
import { Box, Paper, Typography } from '@mui/material'

const PaletteItem: FC<{
  elementType: { value: string; label: string }
}> = ({ elementType }) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `NEW:${elementType.value}`,
    data: {
      type: 'palette',
      elementType: elementType.value,
    },
  })

  return (
    <Box
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      sx={{
        display: 'flex',
        alignItems: 'center',
        py: 1.5,
        px: 2,
        gap: 1.5,
        mb: 1,
        backgroundColor: isDragging ? 'primary.light' : 'background.paper',
        border: '1px solid',
        borderColor: isDragging ? 'primary.main' : 'divider',
        borderRadius: 1,
        cursor: 'grab',
        opacity: isDragging ? 0.5 : 1,
        transition: 'none',
        '&:active': {
          cursor: 'grabbing',
        },
        '&:hover': {
          backgroundColor: 'action.hover',
          borderColor: 'primary.main',
        },
      }}
    >
      <DragIndicator sx={{ color: 'text.secondary', fontSize: 20 }} />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'primary.main',
          mr: 0.5,
        }}
      >
        {FORM_ELEMENT_ICONS[elementType.value]}
      </Box>
      <Typography variant='body2' fontWeight='500'>
        {elementType.label}
      </Typography>
    </Box>
  )
}

export const AvailableElementsPanel: FC = () => {
  return (
    <Paper
      sx={{
        width: 280,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Box
        sx={{
          p: 2,
          borderBottom: theme => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography variant='h6' gutterBottom>
          Available Elements
        </Typography>
        <Typography variant='caption' color='text.secondary'>
          Drag elements to build your form
        </Typography>
      </Box>

      <Box sx={{ flex: 1, overflow: 'auto', p: 2 }}>
        {FORM_ELEMENT_TYPES.map(elementType => (
          <PaletteItem key={elementType.value} elementType={elementType} />
        ))}
      </Box>
    </Paper>
  )
}
